import React from 'react';
import { useTranslation } from 'react-i18next';

import { InputHandler } from '../../../../../viewer/input-handler';
import { SubscriptionTopic } from '../../../../../viewer/messaging/pubsub';
import { useNonce } from '../../../../hooks/use-nonce';
import { useSubscribe } from '../../../../hooks/use-subscribe';
import { ToolIcon } from '../tool-icon';
import { transformMode, transformState } from './utils';

const RotateToolIcon = () => {
  const { t } = useTranslation();
  const [_, refresh] = useNonce();

  useSubscribe(SubscriptionTopic.NewSelection, refresh);
  useSubscribe(SubscriptionTopic.SetTool, refresh);

  return (
    <ToolIcon
      active={transformMode('rotate')}
      callback={() => {
        InputHandler.instance.setTool('transform.rotate');
        refresh();
      }}
      disabled={transformState('rotate')}
      icon={['fal', 'arrow-rotate-right']}
      tooltip={{
        title: t('rotate.tooltip.title', { ns: 'skyviewToolbar' }),
        text: t('rotate.tooltip.text', { ns: 'skyviewToolbar' }),
      }}
    />
  );
};

export { RotateToolIcon };
